import React from 'react'
import SliderAdvertisements from '../SliderAdvertisements'
import hasSlidebarRightAndSecond from '../hoc/hasSlidebarRightAndSecond'
import config from '../config.json'
const breakpoints = config.breakpoints


const CustomAdvertisementSelection = ({
    advertisements,
    selectionId,
    itemSelection,
    itemCollections,
    theme,
    isMobile,
    translation
}) => {
    if(!itemSelection) {
        return ''
    }

    const collectionId = itemSelection.collections[0]
    const collectionItems = itemCollections[collectionId] && itemCollections[collectionId].items ? itemCollections[collectionId].items : []
    const filteredAdvertisements = []

    collectionItems.map(item => {
        if(advertisements.items[item.id] && !_.contains(filteredAdvertisements, advertisements.items[item.id])) {
            filteredAdvertisements.push(advertisements.items[item.id])
        }
    })

    return filteredAdvertisements.length !== 0 && <SliderAdvertisements
        theme={theme}
        items={filteredAdvertisements}
        advertisements={advertisements}
        selectionId={selectionId}
        isMobile={isMobile}
        translation={translation}
        isFront={true}
        scrollToPosition={'slider-custom-placement slider-selection-custom-placement ' + selectionId}
    />
}

export default hasSlidebarRightAndSecond({breakpoint:  breakpoints.desktop})(CustomAdvertisementSelection)